import { render } from "./Awards.vue?vue&type=template&id=45acbc1c&scoped=true"
const script = {}

import "./Awards.vue?vue&type=style&index=0&id=45acbc1c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shawn\\sloppy-golf\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45acbc1c"]])

export default __exports__